import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ChangeDetectorRef,
} from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { DisposalSitesService } from "../disposal-sites.service";
import { ConfirmationService } from "primeng/api";
import { MessageService } from "primeng/api";
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { DynamicDialogConfig } from "primeng/dynamicdialog";
import { DialogService } from "primeng/dynamicdialog";
import { TranslateService } from "@ngx-translate/core";
import { MapsAPILoader, LatLngLiteral } from "@agm/core";
import { JobService } from "../../job/job-data.service";

@Component({
  selector: "app-add-edit-disposal-sites",
  templateUrl: "./add-edit-disposal-sites.component.html",
  styleUrls: ["./add-edit-disposal-sites.component.scss"],
})
export class AddEditDisposalSitesComponent implements OnInit {
  wasteCategoryForm: FormGroup;
  isUpdate = false;
  slide = true;
  isEdit = false;
  isAcumen: any;
  companyID: any;
  companyList = [{ label: "Please Select", value: "" }];
  typeList = [{ label: "Please Select", value: "" }];
  areaList = [{ label: "Please Select", value: "" }];
  data: any = [];
  wasteTypeData = [];
  wasteCategoryList = [];
  allWasteCategoryList = [];
  parentWasteTypesList = [];
  TipSitesForm: FormGroup;
  lat = 54.56848;
  long = -1.3187;
  disposalData = [];
  zoom = 16;
  _data: any;
  isCreating = false;
  isUpdating = false;
  todayDate = "";

  @Input("data") viewData: any = {};
  @Input("isView") isView = false;
  @Output("closeEvents") closeEvents = new EventEmitter<any>();
  constructor(
    private messageService: MessageService,
    private dialogService: DialogService,
    private service: DisposalSitesService,
    private cdr: ChangeDetectorRef,
    private translateService: TranslateService,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private jobService: JobService
  ) {
    this.TipSitesForm = new FormGroup({
      Id: new FormControl("", [Validators.required]),
      // companyId: new FormControl('',[ Validators.required ]),
      Name: new FormControl("", [Validators.required]),
      disposalSiteAdds: new FormControl("", [Validators.required]),
      disposalSiteName: new FormControl("", [Validators.required]),
      Postcode: new FormControl(""),
      contactNo: new FormControl(""),
      location: new FormControl(""),
      area: new FormControl(""),
      type: new FormControl(""),
      parent_waste_category: new FormControl(""),
      min_tonnage: new FormControl(""),
      metal_rebate: new FormControl(""),
      cost_per_tonne: new FormControl(""),
      green_recycle: new FormControl(""),
      global_notes: new FormControl(""),
      company_notes: new FormControl(""),
      warning_notes: new FormControl({ value: "", disabled: true }),
      warning_note_active: new FormControl(false),
      temporary_note: new FormControl({ value: "", disabled: true }),
      temp_note_start_date: new FormControl({ value: "", disabled: true }),
      temp_note_end_date: new FormControl({ value: "", disabled: true }),
      temp_note_active: new FormControl(false),
    });
  }
  companyDepartmentList() {
    this.service.companyList().subscribe((data) => {
      if (data.status === 200) {
        console.log("company list", data);
        data.data.forEach((element) => {
          if (this.isAcumen == "true" || this.isAcumen == true) {
            this.companyList.push({
              label: element.companyName,
              value: element.companyId,
            });
          } else {
            if (element.companyId == this.companyID) {
              this.companyList.push({
                label: element.companyName,
                value: element.companyId,
              });
              if (
                this.isAcumen == "false" ||
                (this.isAcumen == false && !this.isUpdate)
              ) {
                // console.log('abcdefghijk');
                // this.userForm.controls['company'].setValue(element.companyId);
                // this.companyChange(data);
              }
            }
          }
        });
        if (this.isUpdate) {
          //  this.TipSitesForm.controls['companyId'].setValue(this._data.companyId);
        }
      } else {
      }
    });
  }
  autoCompleteCallback1(selectedData: any) {
    if (selectedData.response) {
      this.lat = selectedData.data.geometry.location.lat;
      this.long = selectedData.data.geometry.location.lng;
    }
  }
  
  changePickupMarkerLocation($event: { coords: LatLngLiteral }) {
    this.lat = $event.coords.lat;
    this.long = $event.coords.lng;
  }

  markerDragEnd($event: { coords: LatLngLiteral }) {
    this.lat = $event.coords.lat;
    this.long = $event.coords.lng;
  }

  clickedMarker($event) {}
  private setCurrentPosition() {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.lat = position.coords.latitude;
        this.long = position.coords.longitude;
        this.zoom = 16;
      });
    }
  }
  setTwoNumberDecimal(event, key) {
    let val = this.TipSitesForm.get(key).value.toString();
    //   if (val.indexOf('.') != -1){
    //       if (val.split(".")[1].length > 2){
    this.TipSitesForm.get(key).setValue(parseFloat(val).toFixed(2));
    //  }
    //  }
  }

  private validateWarningNoteFields(): boolean {
    const warningNoteActive = this.TipSitesForm.get("warning_note_active").value;
    const warningNotes = this.TipSitesForm.get("warning_notes").value;
    const tempNoteActive = this.TipSitesForm.get("temp_note_active").value;
    const temporaryNote = this.TipSitesForm.get("temporary_note").value;
    const tempNoteStartDate = this.TipSitesForm.get("temp_note_start_date")
      .value;
    const tempNoteEndDate = this.TipSitesForm.get("temp_note_end_date").value;
    const today = this.todayDate || this.getTodayDateString();

    if (warningNoteActive && !((warningNotes || "").trim())) {
      this.messageService.add({
        severity: "error",
        summary: "Warning note validation",
        detail:
          "Permanent warning note is enabled. Please enter a note or disable it.",
      });
      return false;
    }

    if (tempNoteActive && !((temporaryNote || "").trim())) {
      this.messageService.add({
        severity: "error",
        summary: "Temporary note validation",
        detail:
          "Temporary note is enabled. Please enter a note or disable it.",
      });
      return false;
    }

    if (tempNoteActive && (!tempNoteStartDate || !tempNoteEndDate)) {
      this.messageService.add({
        severity: "error",
        summary: "Temporary note validation",
        detail: "Start date and end date are required for temporary note.",
      });
      return false;
    }

    if (tempNoteEndDate && !tempNoteStartDate) {
      this.messageService.add({
        severity: "error",
        summary: "Temporary note validation",
        detail: "Start date is required when an end date is provided.",
      });
      return false;
    }

    if (tempNoteStartDate && tempNoteStartDate < today) {
      this.messageService.add({
        severity: "error",
        summary: "Temporary note validation",
        detail: "Start date cannot be in the past.",
      });
      return false;
    }

    if (
      tempNoteStartDate &&
      tempNoteEndDate &&
      new Date(tempNoteEndDate) <= new Date(tempNoteStartDate)
    ) {
      this.messageService.add({
        severity: "error",
        summary: "Temporary note validation",
        detail: "End date must be after start date.",
      });
      return false;
    }

    return true;
  }

  private syncWarningNoteFieldsState() {
    const isWarningNoteActive = this.TipSitesForm.get("warning_note_active").value;
    const warningNoteFields = ["warning_notes"];

    warningNoteFields.forEach((key) => {
      const control = this.TipSitesForm.get(key);
      if (isWarningNoteActive) {
        control.enable({ emitEvent: false });
      } else {
        control.disable({ emitEvent: false });
      }
    });
  }

  private syncTemporaryNoteFieldsState() {
    const isTempNoteActive = this.TipSitesForm.get("temp_note_active").value;
    const tempNoteFields = [
      "temporary_note",
      "temp_note_start_date",
      "temp_note_end_date",
    ];

    tempNoteFields.forEach((key) => {
      const control = this.TipSitesForm.get(key);
      if (isTempNoteActive) {
        control.enable({ emitEvent: false });
      } else {
        control.disable({ emitEvent: false });
      }
    });
  }

  ngOnInit() {
    this.todayDate = this.getTodayDateString();
    this.companyID = localStorage.getItem("companyID");
    this.isAcumen = localStorage.getItem("isAcumen");
    this.loadData();
    this.syncWarningNoteFieldsState();
    this.syncTemporaryNoteFieldsState();
    this.TipSitesForm.get("warning_note_active").valueChanges.subscribe(() => {
      this.syncWarningNoteFieldsState();
    });
    this.TipSitesForm.get("temp_note_active").valueChanges.subscribe(() => {
      this.syncTemporaryNoteFieldsState();
    });
    this.companyDepartmentList();
    this.loadListAPI();
    //this.searchControl = new FormControl();
    //      this.mapsAPILoader.load().then(() => {
    //        const autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement,{ types:['address']});
    //        autocomplete.setFields(['address_components', 'geometry', 'icon', 'name']);
    //        autocomplete.addListener('place_changed', () => {
    //            this.ngZone.run(() => {
    //                const place = autocomplete.getPlace();

    //                if (place.geometry === undefined || place.geometry === null) {
    //                    return;
    //                }
    //                this.lat = place.geometry.location.lat();
    //                this.long = place.geometry.location.lng();
    //                this.zoom = 16;
    //            });
    //        });
    //    });
  }

  private getTodayDateString(): string {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  getTempNoteEndMinDate(): string {
    return this.TipSitesForm.get("temp_note_start_date").value || this.todayDate;
  }

  private formatDateForInput(value: any): string {
    if (!value) {
      return "";
    }

    const textValue = String(value);
    if (textValue.includes("T")) {
      return textValue.split("T")[0];
    }

    return textValue;
  }

  loadListAPI() {
    this.service.parentWasteTypes({}).subscribe((response) => {
      console.log("response parentWasteTypesList", response);
      if (response.length > 0) {
        response.forEach((element) => {
          let data;
          data = {
            label: element.ewc_code + " - " + element.code_description,
            value: element.ewc_code,
          };
          this.parentWasteTypesList.push(data);
          if (this.isUpdate) {
            const disposal = [];
            if (this._data.disposal_type_details) {
              if (
                this._data.disposal_type_details.parent_waste_category.length >
                0
              ) {
                this.disposalData =
                  this._data.disposal_type_details.parent_waste_category;
                this._data.disposal_type_details.parent_waste_category.forEach(
                  (element) => {
                    disposal.push(element.ewc_code);
                  }
                );
              }
            }
            this.TipSitesForm.controls["parent_waste_category"].setValue(
              disposal
            );
          }
        });
        console.log("response parentWasteTypesList", this.parentWasteTypesList);
      }
    });
    this.service.typeList().subscribe((data) => {
      console.log("type list", data);
      data.forEach((element) => {
        this.typeList.push({ label: element.name, value: element._id });
      });
      if (this.isUpdate) {
        this.TipSitesForm.controls["type"].setValue(this._data.type);
      }
    });
    this.service.areaList().subscribe((data) => {
      console.log("area list", data);
      data.forEach((element) => {
        this.areaList.push({ label: element.name, value: element._id });
      });
      if (this.isUpdate) {
        this.TipSitesForm.controls["area"].setValue(this._data.area);
      }
    });
  }

  updateDisposal(event: any) {
    if (this.isUpdating || this.isCreating) {
      return;
    }

    let value: any = "";
    const disposal = [];
    value = this.TipSitesForm.getRawValue();
    value.location = { lat: this.lat, long: this.long };
    value.externalSiteId = parseInt(this.TipSitesForm.get('Id').value);
    value.companyId = this.data.companyId;
    if (value.type == "5e54d71d50b3a90c698c8393") {
      if (!this.validateWarningNoteFields()) {
        return;
      }

      if (value.parent_waste_category.length > 0) {
        value.parent_waste_category.forEach((element) => {
          let data;
          if (this.disposalData.length > 0) {
            var exists = this.disposalData.find(
              ({ ewc_code }) => element === ewc_code
            );
            if (exists) {
              const subArr = [];
              let val;
              if (exists.sub_waste_category.length > 0) {
                exists.sub_waste_category.forEach((e2) => {
                  const subSubArr = [];
                  if (e2.sub_sub_waste_category.length > 0) {
                    e2.sub_sub_waste_category.forEach((e3) => {
                      subSubArr.push(e3.ewc_code);
                    });
                  }
                  val = {
                    ewc_code: e2.ewc_code,
                    sub_sub_waste_category: subSubArr,
                  };
                  subArr.push(val);
                });
              }
              data = { ewc_code: exists.ewc_code, sub_waste_category: subArr };
              disposal.push(data);
            } else {
              data = { ewc_code: element, sub_waste_category: [] };
              disposal.push(data);
            }
          } else {
            data = { ewc_code: element, sub_waste_category: [] };
            disposal.push(data);
          }
        });
      }

      value.disposal_type_details = {
        parent_waste_category: disposal,
        price: this._data.disposal_type_details.price,
        min_tonnage: value.min_tonnage,
        metal_rebate: value.metal_rebate,
        cost_per_tonne: value.cost_per_tonne,
        green_recycle: value.green_recycle,
        //opening_hours: value.opening_hours,
        warning_notes: value.warning_notes,
        warning_note_active: value.warning_note_active,
        temporary_note: value.temporary_note,
        temp_note_start_date: value.temp_note_start_date,
        temp_note_end_date: value.temp_note_end_date,
        temp_note_active: value.temp_note_active,
        global_notes: value.global_notes,
        company_notes: value.company_notes,
      };
    }
    delete value.parent_waste_category;
    delete value.min_tonnage;
    delete value.metal_rebate;
    delete value.cost_per_tonne;    
    delete value.green_recycle;
    //delete value.opening_hours;
    delete value.warning_notes;
    delete value.warning_note_active;
    delete value.temporary_note;
    delete value.temp_note_start_date;
    delete value.temp_note_end_date;
    delete value.temp_note_active;
    delete value.global_notes;
    delete value.company_notes;
    value._id = this._data._id;
    value.Id = this._data.Id;
    //value.externalSiteId = this.data.externalSiteId;
    console.log(value)
    this.isUpdating = true;
    this.service.updateDisposalLocation(value).subscribe((data: any) => {
      if (data.status === 200) {
        if (this.isEdit == true) {
          this.service.getDisposalDetails(value._id).subscribe((response) => {
            this.viewData = response.data;
            this.viewData.externalSiteId = value.externalSiteId
            this.closeEvent(event);
          });
        } else {
          this.closeEvent(event);
        }
        this.messageService.add({
          severity: "success",
          summary: "Update Disposal site",
          detail: "Tip site details updated successfully",
        });
        this.isUpdating = false;
      } else if (data.status === 500) {
        this.messageService.add({
          severity: "error",
          summary: "Update Disposal site",
          detail: data.error.message.errmsg,
        });
        this.isUpdating = false;
      } else {
        this.messageService.add({
          severity: "error",
          summary: "Update Disposal site",
          // detail: 'Failed to quotes the Tip site details'
          detail: "Unable to update Tip site.Please try again.",
        });
        this.isUpdating = false;
      }
    },
    () => {
      this.isUpdating = false;
      this.messageService.add({
        severity: "error",
        summary: "Update Disposal site",
        detail: "Unable to update Tip site.Please try again.",
      });
    });
  }
  createDisposal(e: any) {
    if (this.isCreating || this.isUpdating) {
      return;
    }

    console.log('central data',e)
    e.preventDefault();
    let quotesData: any = "";
    const disposal = [];
    quotesData = this.TipSitesForm.getRawValue();
    quotesData.location = { lat: this.lat, long: this.long };
    quotesData.externalSiteId = parseInt(this.TipSitesForm.get('Id').value)
    let selectedtypeName = this.typeList.find(
      (x) => x.value === this.TipSitesForm.value.type
    );
    if (selectedtypeName.label == "Disposal") {
      if (!this.validateWarningNoteFields()) {
        return;
      }

      if (quotesData.parent_waste_category.length > 0) {
        quotesData.parent_waste_category.forEach((element) => {
          let data;
          data = { ewc_code: element, sub_waste_category: [] };
          disposal.push(data);
        });
      }
      quotesData.disposal_type_details = {
        parent_waste_category: disposal,
        min_tonnage: quotesData.min_tonnage,
        metal_rebate: quotesData.metal_rebate,
        cost_per_tonne: quotesData.cost_per_tonne,
        green_recycle: quotesData.green_recycle,
        // opening_hours: quotesData.opening_hours,
        warning_notes: quotesData.warning_notes,
        warning_note_active: quotesData.warning_note_active,
        temporary_note: quotesData.temporary_note,
        temp_note_start_date: quotesData.temp_note_start_date,
        temp_note_end_date: quotesData.temp_note_end_date,
        temp_note_active: quotesData.temp_note_active,
        global_notes: quotesData.global_notes,
        company_notes: quotesData.company_notes,
      };
    }
    delete quotesData.parent_waste_category;
    delete quotesData.min_tonnage;
    delete quotesData.metal_rebate;
    delete quotesData.cost_per_tonne;
    delete quotesData.green_recycle;
    //delete quotesData.opening_hours;
    delete quotesData.warning_notes;
    delete quotesData.warning_note_active;
    delete quotesData.temporary_note;
    delete quotesData.temp_note_start_date;
    delete quotesData.temp_note_end_date;
    delete quotesData.temp_note_active;
    delete quotesData.global_notes;
    delete quotesData.company_notes;
    console.log("data", quotesData);
    if(selectedtypeName.label == "Central"){
      quotesData.isCenteralLocation = true;
    }
    this.isCreating = true;
    this.service.createDisposalLocation(quotesData).subscribe(
      (data: any) => {
        if (data.status === 200) {
          this.messageService.add({
            severity: "success",
            summary: "Create Disposal site",
            detail: "New Disposal site created successfully",
          });
          this.closeEvent(event);
          this.isCreating = false;
        } else if (data.status === 500) {
          this.messageService.add({
            severity: "error",
            summary: "Create Disposal site",
            detail: data.error.message.errmsg,
          });
          this.isCreating = false;
        } else {
          this.messageService.add({
            severity: "error",
            summary: "Create Disposal site",
            //  detail: 'Failed to create the Tip sites'
            detail: "Unable to add Disposal site.Please try again.",
          });
          this.isCreating = false;
        }
      },
      (err) => {
        this.isCreating = false;
        this.messageService.add({
          severity: "error",
          summary: "Create Disposal site",
          // detail: 'Failed to create the Tip sites'
          detail: "Unable to add Tip site.Please try again.",
        });
        //  this.dialogService.closeAll();
      }
    );
  }

  editEvent(event) {
    this.isEdit = true;
    this.isUpdate = true;
    this.isView = false;
    this.loadData();
  }

  loadData() {
    if (this.viewData && Object.keys(this.viewData).length !== 0) {
      console.log(" true vehicleData", this.viewData);
      this._data = this.viewData;
      this.data = this.viewData;
      console.log(this.data )
      this.isUpdate = true;
      if (this.isUpdate) {
        this.lat = this.data.location ? this.data.location.lat : 54.56848;
        this.long = this.data.location ? this.data.location.long : -1.3187;
        this.TipSitesForm.controls["Id"].setValue(this.data.externalSiteId);
        this.TipSitesForm.controls["Name"].setValue(this.data.Name);
        // this.TipSitesForm.controls['companyId'].setValue(this.data.companyId);
        this.TipSitesForm.controls["disposalSiteAdds"].setValue(
          this.data.disposalSiteAdds
        );
        this.TipSitesForm.controls["disposalSiteName"].setValue(
          this.data.disposalSiteName
        );
        this.TipSitesForm.controls["contactNo"].setValue(this.data.contactNo);
        this.TipSitesForm.controls["Postcode"].setValue(this.data.Postcode);
        this.TipSitesForm.controls["location"].setValue(this.data.location);
        this.TipSitesForm.controls["type"].setValue(this.data.type);
        if (this.data.disposal_type_details) {
          this.TipSitesForm.controls["parent_waste_category"].setValue(
            this.data.disposal_type_details.parent_waste_category
          );
          this.TipSitesForm.controls["min_tonnage"].setValue(
            this.data.disposal_type_details.min_tonnage
          );
          this.TipSitesForm.controls["metal_rebate"].setValue(
            this.data.disposal_type_details.metal_rebate
          );
          this.TipSitesForm.controls["cost_per_tonne"].setValue(
            this.data.disposal_type_details.cost_per_tonne
          );
          this.TipSitesForm.controls["green_recycle"].setValue(
            this.data.disposal_type_details.green_recycle
          );
          // this.TipSitesForm.controls['opening_hours'].setValue(data.disposal_type_details.opening_hours);
          this.TipSitesForm.controls["warning_notes"].setValue(
            this.data.disposal_type_details.warning_notes || ""
          );
          this.TipSitesForm.controls["warning_note_active"].setValue(
            !!this.data.disposal_type_details.warning_note_active
          );
          this.TipSitesForm.controls["temporary_note"].setValue(
            this.data.disposal_type_details.temporary_note || ""
          );
          this.TipSitesForm.controls["temp_note_start_date"].setValue(
            this.formatDateForInput(
              this.data.disposal_type_details.temp_note_start_date
            )
          );
          this.TipSitesForm.controls["temp_note_end_date"].setValue(
            this.formatDateForInput(
              this.data.disposal_type_details.temp_note_end_date
            )
          );
          this.TipSitesForm.controls["temp_note_active"].setValue(
            !!this.data.disposal_type_details.temp_note_active
          );
          this.syncWarningNoteFieldsState();
          this.syncTemporaryNoteFieldsState();
          this.TipSitesForm.controls["global_notes"].setValue(
            this.data.disposal_type_details.global_notes
          );
          this.TipSitesForm.controls["company_notes"].setValue(
            this.data.disposal_type_details.company_notes
          );
        }
        if (this.isView) {
        }
      }
    }
  }
  closeEvent(event) {
    if (this.isEdit == false) {
      this.slide = false;
      this.cdr.detectChanges();
      setTimeout((e) => {
        this.closeEvents.emit(true);
      }, 1000);
    } else {
      this.isEdit = false;
      this.isView = true;
      this.isUpdate = false;
      this.loadData();
    }
  }

  blockSpecialChar(e) {
    console.log("key press: ", e);
    var k;
    document.all ? (k = e.keyCode) : (k = e.which);
    return (
      (k > 64 && k < 91) ||
      (k > 96 && k < 123) ||
      k == 8 ||
      k == 32 ||
      (k >= 48 && k <= 57)
    );
  }
  checkPermissions(type, module) {
    return this.jobService.checkPermissions(type, module);
  }
}
